const jiraIcon = `
<svg
   width="42px"
   height="42px"
   viewBox="0 0 90.410271 93.309723"
   version="1.1"
   id="jira-icon"
   xml:space="preserve"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2" /><g
     id="layer1"
     transform="translate(-59.52186,-26.708551)"><path
       style="stroke-width:0.352778"
       d="M 82.007702,97.522234 59.521858,75.02619 V 73.450907 71.87562 L 82.099637,49.292085 104.67742,26.70855 l 22.62736,22.633134 22.62736,22.633134 -0.18821,1.669729 -0.1882,1.669732 -22.34992,22.351998 c -12.29246,12.293603 -22.43145,22.352003 -22.53109,22.352003 -0.0996,0 -10.299806,-10.12322 -22.667018,-22.496046 z m 29.373688,-17.545435 6.52044,-6.527592 -6.61221,-6.612206 -6.6122,-6.612206 -6.61221,6.612206 -6.61221,6.612206 6.520438,6.527592 c 3.586242,3.590174 6.603032,6.527589 6.703982,6.527589 0.10094,0 3.11773,-2.937415 6.70397,-6.527589 z"
       id="path314" /></g></svg>`;

export default jiraIcon;
